'use client';

import { createContext } from 'react';

import type { LANGUAGES } from '@crehana/ts-types';

import { cookieValues } from '@/shared/utils/cookies';

type TContext = LANGUAGES;

type TLanguageProviderProps = {
  children: React.ReactNode;
};

export const Context = createContext<TContext | undefined>(undefined);

export const LanguageProvider = ({ children }: TLanguageProviderProps) => {
  return (
    <Context.Provider value={cookieValues.language}>
      {children}
    </Context.Provider>
  );
};
